module.exports = __webpack_public_path__ + "img/logo.a1cc7743.jpg";